import { LocalShippingOutlined as LocalShippingIcon, LocalAtmOutlined as LocalAtmIcon } from '@mui/icons-material';
import { BOT_INTENTS } from './intents';
import { QuickActionItem, GeneralSuggestionItem } from '../types/intent.types';

export const DEFAULT_QUICK_ACTIONS: QuickActionItem[] = [
  {
    label: 'Create Shipment',
    query: 'Create shipment',
    intent: BOT_INTENTS.PLACE_SHIPMENT,
    icon: LocalShippingIcon,
  },
  // {
  //   label: 'Create Invoice',
  //   query: 'Create invoice',
  //   intent: BOT_INTENTS.CREATE_INVOICE,
  //   icon: ReceiptIcon,
  // },
  // {
  //   label: 'Download Reports',
  //   query: 'Download reports',
  //   intent: BOT_INTENTS.DOWNLOAD_REPORT,
  //   icon: CloudDownloadIcon,
  // },
  {
    label: 'Get Rates',
    query: 'Get rates',
    intent: BOT_INTENTS.GET_RATES,
    icon: LocalAtmIcon,
  },
  // {
  //   label: 'Find Quotes',
  //   query: 'Find quotes',
  //   intent: BOT_INTENTS.FIND_QUOTES,
  //   icon: SearchIcon,
  // },
];

export const DEFAULT_GENERAL_SUGGESTIONS: GeneralSuggestionItem[] = [
  {
    label: 'Track Shipment',
    query: 'Track shipment',
    intent: null,
  },
  // {
  //   label: 'Shipment Status',
  //   query: 'Shipment status',
  //   intent: null,
  // },
  {
    label: 'Find Rate / Quotes',
    query: 'Find rate / quotes',
    intent: null,
  },
  // {
  //   label: 'Download Report',
  //   query: 'Download report',
  //   intent: null,
  // },
  // {
  //   label: 'Repeat Shipment',
  //   query: 'Repeat shipment',
  //   intent: null,
  // },
];
